import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';


import { Provider } from 'react-redux';
import store from './store';

import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';

import {Amplify} from 'aws-amplify';
import awsExports from './aws-exports'; // Ensure the path is correct

import { AuthProvider } from './context/AuthContext';

Amplify.configure(awsExports);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
    <Provider store={store}>
      <ThemeProvider theme={theme}>
      
        <AuthProvider>
          <App />
        </AuthProvider>     
      
      </ThemeProvider>
    </Provider>
  
);

